import React, {FormHTMLAttributes, ReactElement, ReactNode} from "react";

interface FormGroupProps {
    groupTitle: ReactNode
    error?: ReactNode | null | undefined
    icon?: ReactElement | null | undefined
    children: ReactNode
    chars?: number
    maxChars?: number
}

export function FormGroup(props: FormGroupProps & FormHTMLAttributes<HTMLFormElement>): ReactElement {
    const hasError = props.error != null;
    return (
        <div className="flex flex-col gap-2">
            <span className="text-xs leading-tight">{props.groupTitle}</span>
            <div>
                {props.children}
            </div>
            <div className="flex justify-between">
                <span className="text-primary">
                    {hasError && props.error}
                </span>
                {typeof props.chars === 'number' && <span>
                    {props.chars}{typeof props.maxChars === 'number' && <>/{props.maxChars}</>}
                </span>}
            </div>
        </div>
    );
}